<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['hotel_booking_cancellations.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">
        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.TITLE' | translate }}
      </h5>
    </div>
    <div class="col-auto ms-auto">
      <div>
        <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
      </div>
      <!--      <button type="button" class="btn btn-secondary" aria-label="Add" (click)="add()">-->
      <!--        {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.ADD' | translate }}-->
      <!--      </button>-->
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="hotelBookingCancellationResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="booking.id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.BOOKING_ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('booking.id')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/hotel-bookings/view']" [queryParams]="{ id: dataItem.booking?.id }" target="_blank">
          {{ dataItem.booking?.id }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.company.abbreviation"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.company.abbreviation')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter" [field]="'booking.company_id'"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          [routerLink]="['/settings/companies/view']"
          [queryParams]="{ id: dataItem?.booking.company_id }"
          target="_blank"
        >
          {{ dataItem?.booking?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.hotel.name"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.HOTEL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.hotel.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-hotel-select [filter]="filter" [field]="'booking.hotel_id'"></app-kendo-hotel-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a [routerLink]="'/hotels/view'" [queryParams]="{ id: dataItem.booking?.hotel_id }" target="_blank">
          {{ dataItem?.booking?.hotel?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.ref_number"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.REF_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.ref_number')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="booking.events.name"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.EVENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.events.name')"
      [filterable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let event of dataItem?.booking?.events; let i = index">
          <a [routerLink]="['/events/view']" [queryParams]="{ id: event.id }" target="_blank">
            {{ event.name }} <span *ngIf="i + 1 !== dataItem?.booking?.events.length">,</span>
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.supplier.name"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.SUPPLIER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.company')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-supplier-select [filter]="filter" [field]="'booking.supplier_id'"></app-kendo-supplier-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.cancellation_deadline"
      title="{{
        'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.BOOKING_CANCELLATION_DEADLINE' | translate
      }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('booking.cancellation_deadline')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.booking.cancellation_deadline | date : env.pipeDateFormat }}
        <span *ngIf="dataItem?.booking?.cancellation_deadline">
          (
          {{
            dataItem?.booking?.cancellation_deadline | amParse : env.apiPipeDateFormat | amDifference : moment : 'days'
          }}
          {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.DAYS' | translate }}
          )
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.payment_deadline"
      title="{{
        'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.BOOKING_PAYMENT_DEADLINE' | translate
      }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('booking.payment_deadline', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.booking.payment_deadline | date : env.pipeDateFormat }}
        <span *ngIf="dataItem?.booking?.payment_deadline">
          (
          {{ dataItem?.booking?.payment_deadline | amParse : env.apiPipeDateFormat | amDifference : moment : 'days' }}
          {{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.DAYS' | translate }}
          )
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="created_at"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('created_at')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="note"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.NOTE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('note')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="booking.contracting_agent_id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.CONTRACTING_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.contracting_agent_id')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.CONTRACTING_AGENT]"
          [field]="'booking.contracting_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.booking?.contracting_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.reservation_agent_id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.RESERVATION_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.reservation_agent_id')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.RESERVATION_AGENT]"
          [field]="'booking.reservation_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.booking?.reservation_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.amendment_agent_id"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.AMENDMENT_AGENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.amendment_agent_id', false)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-user-select
          [filter]="filter"
          [roleType]="[UserRoleType.AMENDMENT_AGENT]"
          [field]="'booking.amendment_agent_id'"
        ></app-kendo-user-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem?.booking?.amendment_agent?.names }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="finished"
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.FINISHED' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('finished')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.finished"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_booking_cancellations.show']
            )
          "
          class="btn btn-warning btn-ico"
          [routerLink]="['/hotel-booking-cancellations/view']"
          [queryParams]="{ id: dataItem.id }"
          [ngbTooltip]="'HOTELS_BOOKING_CANCELLATIONS.HOTEL_BOOKINGS_CANCELLATIONS_LIST.EDIT_CANCELLATION' | translate"
          container="body"
        >
          <i class="fal fa-pencil"></i>
        </a>

        <app-download-rooming-list-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.export_sold_rooms']
            )
          "
          [bookingId]="dataItem?.booking?.id"
          [iconButton]="true"
        >
        </app-download-rooming-list-button>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_booking_cancellations.destroy']
            )
          "
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
    </ng-template>
  </kendo-grid>
</div>
